import React from 'react';
import Popper from '@material-ui/core/Popper';
import User, {MediaflySolution} from 'records/User';
import './AppSwitcher.scss';

const SOLUTION_INFO_LINK = 'https://www.mediafly.com/solutions/';
const SOLUTION_LAUNCH_LINK = 'https://login.mediafly.com/launch/';

interface AppSwitcherProps {
  open: boolean;
  user: User;
  anchorEl: HTMLButtonElement | null;
}

export const AppSwitcher: React.FC<AppSwitcherProps> = ({open, user, anchorEl}) => {
  return (
    <Popper className="app-switcher-popper" open={open} anchorEl={anchorEl} placement="right-start">
      <div className="app-switcher">
        <h4>Switch To</h4>
        {user
          .solutionList!.filter(solution => solution !== MediaflySolution.Coach360)
          .map(solution => solutionInfo[solution])
          .sort((a, b) => a.sortOrder - b.sortOrder)
          .map((solution, index) => (
            <SolutionItem solution={solution} tenantId={user.tenantId!} key={index} />
          ))}
        <div className="footer">
          Powered By <span>Mediafly</span>
        </div>
      </div>
    </Popper>
  );
};

interface MediaflySolutionInfo {
  mediaflySolution: MediaflySolution;
  name: string;
  description: string;
  sortOrder: number;
}

const solutionInfo: Record<MediaflySolution, MediaflySolutionInfo> = {
  [MediaflySolution.Coach360]: {
    mediaflySolution: MediaflySolution.Coach360,
    name: 'Coach',
    description: 'Call Recording, Coaching',
    sortOrder: 0,
  },
  [MediaflySolution.Intelligence360]: {
    mediaflySolution: MediaflySolution.Intelligence360,
    name: 'Intelligence',
    description: 'Dashboard, Analytics, Call Recording',
    sortOrder: 0,
  },
  [MediaflySolution.Engagement360]: {
    mediaflySolution: MediaflySolution.Engagement360,
    name: 'Engagement',
    description: 'Content, Value Tools, Workspaces',
    sortOrder: 0,
  },
  [MediaflySolution.Revenue360]: {
    mediaflySolution: MediaflySolution.Revenue360,
    name: 'Global User Management',
    description: 'Your Profile, Global User Management',
    sortOrder: 999, // Last in the list, always
  },
  [MediaflySolution.Value360]: {
    mediaflySolution: MediaflySolution.Value360,
    name: 'Value',
    description: 'ROI Calculations',
    sortOrder: 0,
  },
};

interface SolutionItemProps {
  solution: MediaflySolutionInfo;
  unavailable?: boolean;
  tenantId: string;
}
function SolutionItem({solution, unavailable, tenantId}: SolutionItemProps) {
  const {name, description, mediaflySolution} = solution;
  const link = unavailable
    ? SOLUTION_INFO_LINK + mediaflySolution
    : `${SOLUTION_LAUNCH_LINK}${mediaflySolution}?tenantId=${tenantId}`;

  return (
    <a
      href={link}
      target={unavailable ? '_blank' : ''}
      rel="noreferrer"
      style={{margin: '.5rem 0'}}>
      <div className="solution-item">
        <div className="solution-info">
          <div className="solution-name">{name}</div>
          <div className="solution-description">{description}</div>
        </div>
      </div>
    </a>
  );
}
